// Dynamically sets the publicPath for webpack loaders using the resourceEndpoint value taken from the server app settings configuration
if (ENV_PROD) {
    const PUBLIC_PATH = window.sa.resourceEndpoint + "/";
    // important note: Using this in dev environment breaks hot reloading
    __webpack_public_path__ = PUBLIC_PATH;
}